import { initHeader } from '@/widgets/header/header';
import {HeaderSearch} from '@/widgets/header/header-search/header-search.js';

window.addEventListener('DOMContentLoaded', () => {
	initHeader();
	document.querySelectorAll('.header-search').forEach((element) => new HeaderSearch(element));
});
